import MemberRole from "./MemberRole";

class Member {
    id: string;
    name: string;
    role: MemberRole;
    profileImage: string;

    constructor(id: string, nickname: string, role: MemberRole, profileImage: string) {
        this.id = id;
        this.name = nickname;
        this.role = role;
        this.profileImage = profileImage;
    }

    static fromJson(json: any) {
        return new Member(
            json.id,
            json.name,
            json.role as MemberRole,
            json.profileImage,
        )
    }
}

export default Member;